module.exports = __webpack_public_path__ + "static/img/pingxing.47c4fe00.png";